import React from "react";
import { useChallenge } from "@/context/ChallengeContext";
import { PageHeader, GoalBar, Stat, DisclaimerFooter } from "@/components/Bits";
import { fmtUSD, fmtPct, fmtDatePL } from "@/lib/calc";

export default function Stats() {
  const { data } = useChallenge();
  if (!data) return <div className="text-demon-muted font-mono py-20 text-center">Ładowanie...</div>;

  const s = data.stats;
  const cfg = data.config;

  return (
    <div>
      <PageHeader title="Challenge Stats" subtitle="Pełne podsumowanie wyników challenge'u." />

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
        <Stat label="DNI UKOŃCZONE" value={s.completed_days} testid="stat-completed" />
        <Stat label="DNI WYGRANE" value={s.win_days} accent="green" testid="stat-win-days" />
        <Stat label="DNI STRATNE" value={s.loss_days} accent="red" testid="stat-loss-days" />
        <Stat label="LICZBA TRANSAKCJI" value={s.total_trades} testid="stat-trades" />
        <Stat label="TP" value={s.tp_count} accent="green" />
        <Stat label="SL" value={s.sl_count} accent="red" />
        <Stat label="BE" value={s.be_count} />
        <Stat label="WIN RATE" value={fmtPct(s.win_rate, 1)} accent="violet" testid="stat-winrate" />
        <Stat label="CAŁKOWITY PROFIT" value={(s.total_profit >= 0 ? "+" : "") + fmtUSD(s.total_profit)} accent={s.total_profit >= 0 ? "green" : "red"} testid="stat-total-profit" />
        <Stat label="NAJWIĘKSZY PROFIT" value={"+" + fmtUSD(s.biggest_profit)} accent="green" />
        <Stat label="NAJWIĘKSZA STRATA" value={fmtUSD(s.biggest_loss)} accent="red" />
        <Stat label="AKTUALNY KAPITAŁ" value={fmtUSD(s.current_balance)} accent="violet" />
        <Stat label="MAX DRAWDOWN" value={fmtPct(s.max_drawdown)} accent="gold" testid="stat-drawdown" />
        <Stat
          label="NAJLEPSZY DZIEŃ"
          value={s.best_day ? `+${fmtUSD(s.best_day.profit)}` : "—"}
          accent="green"
        />
        <Stat
          label="NAJGORSZY DZIEŃ"
          value={s.worst_day ? fmtUSD(s.worst_day.profit) : "—"}
          accent="red"
        />
      </div>

      <h2 className="font-display text-2xl font-bold mb-4">Cel i progres</h2>
      <div className="max-w-2xl">
        <div className="glow-card rounded-2xl p-6 border-amber-500/30">
          <div className="font-display text-3xl font-extrabold gold-glow text-amber-400 mb-4">$200,000</div>
          <GoalBar label="$350 → aktualny → $200,000" current={s.current_balance} target={cfg.goal_2} color="gold" testid="stats-goal-200k" />
        </div>
      </div>

      <DisclaimerFooter />
    </div>
  );
}
